import React from 'react';
import ProjectInfoWrapper from '../ProjectInfoWrapper';
import SNavigation from '../SNavigation';

const TranscriptRoute = ({ transcriptID, projectID, page, codeID, rightSideBar }) => (
  <ProjectInfoWrapper
    projectID={projectID}
  >
    <SNavigation
      transcriptID={transcriptID}
      page={page}
      rightSideBar={rightSideBar}
      codeID={codeID}
    />
  </ProjectInfoWrapper>
);

export default TranscriptRoute;
